<template lang="pug">
.shared-edit-field
  #billable.form-group.mb-20
    .checkbox
      AppOnOffToggle(
        :value="billable"
        :disabled="!canManageDetails"
        @input="$emit('update:billable', $event)"
      )
        span Billable
  #track-input.form-group.mb-20(v-if="activityTrackingAllowed")
    .checkbox
      AppOnOffToggle(
        :value="monitorUserActivity"
        :disabled="!canManageDetails"
        @input="$emit('update:monitorUserActivity', $event)"
      )
        span.d-flex.align-items-center Disable activity
          i.hi.hi-info-filled.hi-12.a-tooltip.ml-5(
            v-tooltip="{ placement: 'bottom' }"
            title="When enabled, this will no longer record activity for any members tracking time to this project. This is often used on any projects related to calls or meetings."
          )
  #project-tracking-input.form-group.mb-20
    .checkbox
      AppOnOffToggle(
        :value="!effectiveDisableProjectTracking"
        :disabled="!canManageDetails"
        @input="$emit('update:disableProjectTracking', !$event)"
      )
        span.d-flex.align-items-center Allow project tracking
          i.hi.hi-info-filled.hi-12.a-tooltip.ml-5(
            v-tooltip="{ placement: 'bottom' }"
            title="When enabled, members can track time directly to the project without selecting a task."
          )
</template>

<script>
export default {
  props: {
    billable: {
      type: Boolean,
      default: false,
    },
    monitorUserActivity: {
      type: Boolean,
      default: false,
    },
    disableProjectTracking: {
      type: Boolean,
      default: false,
    },
    organization: {
      type: Object,
      default: () => ({}),
    },
    isNewForm: {
      type: Boolean,
      default: false,
    },
    activityTrackingAllowed: {
      type: Boolean,
      required: true,
    },
    canManageDetails: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    effectiveDisableProjectTracking() {
      if (this.isNewForm && this.organization?.settings?.disable_project_tracking !== undefined) {
        return this.organization.settings.disable_project_tracking;
      }

      return this.disableProjectTracking;
    },
  },
};
</script>
